import { ReactNode } from "react";

declare interface ContainerProps {
  children: ReactNode;
}

export function Container({children} : ContainerProps): JSX.Element {
  return (
    <div className='w-full p-8 bg-slate-50 dark:bg-slate-700 text-gray-800 dark:text-gray-100'>
      {children}
    </div>
  )
}
